import { render, staticRenderFns } from "./ChatContent.vue?vue&type=template&id=f7335f6a"
import script from "./ChatContent.vue?vue&type=script&lang=js"
export * from "./ChatContent.vue?vue&type=script&lang=js"
import style0 from "./ChatContent.vue?vue&type=style&index=0&id=f7335f6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports